import outAxios from '@/plugins/axios2'
import apiClient from '@/plugins/axios'
import JSZip from '@/plugins/jszip'
import axiosExt from 'axios';
import procImages from '@/mixins/procImages'


const sleep = (ms) => new Promise(r => setTimeout(r, ms));

export default {
  mixins: [procImages],
  generateFileToUpload(file) {
    return new Promise(async (resolve, reject) => {

      //redimensionar e reajusta qualidade da imagem
      if ( /\.(jpe?g|png|gif)$/i.test( file.name ) ) {
        try {
          file = await procImages.resizeImage(file)
        } catch (error) {
          reject (error)
        }
      }

      let img = { id: '', loading: false, processo_id: this.processo_id, nome: '', isEnviar: true, isErro: false }

      //gera preview e redimensiona imagens
      try {
        const newFile = await procImages.geraArquivoUpload(file)
        img.preview = newFile.preview
        img.filedata = newFile.filedata
        img.name = newFile.name.toUpperCase()
        img.ext = newFile.extensao
        img.type = newFile.type
        img.tipo = newFile.tipo
        img.size = newFile.size
        img.nome = newFile.name.toUpperCase().split('.', 1)
        img.downloadFile = false,
        img.progressFile = null,
        img.isMultiSelecionado = false,
        img.isUploading = false
        img.nm_fileorig = newFile.nm_fileorig
        resolve(img)

      } catch(e) {
        reject(e)
      }
    })    
  },


  geraUrlDropBox (item, url, parent_id, folderExisteDropBox) {
    return new Promise((resolve, reject) => {
        item.createFolder = folderExisteDropBox ? false : true
        apiClient.post(`${url}/dropbox/link/upload`, {
          "parent_id": parent_id, "ext": item.ext, name: item.name, createFolder: item.createFolder
        })
        .then(respLink => {
          if (respLink.data.status) {

            if (!respLink.data.url) {
              reject("Erro ao gerar URL no servidor de Armazenamento.")
            }

            if (!folderExisteDropBox) {
              folderExisteDropBox = true
            }
            let retorno = { urlupload: respLink.data.url, filename: respLink.data.filename, folderExisteDropBox }
            resolve(retorno)
            
          } else {
            reject("Erro ao gerar URL to Upload File")
          }
        })
        .catch ((error) => {
          reject(error)
        })
    }) 
  },



  uploadFileToUrlDropBox (item, url) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        item.downloadFile = true
        item.progressFile = 0
        outAxios({
          method: 'POST',
          url,
          data: item.filedata,
          headers: {'Content-Type': 'application/octet-stream'},
          transformRequest: [(data, headers) => {
            delete headers.common.Authorization
            return data
          }],
          onUploadProgress: (progressEvent) => {
            item.progressFile = Math.round(((progressEvent.loaded * 100) / progressEvent.total)-2);
          }
        })
        .then((response) => {
          if (!response.data['content-hash']) { 
            reject('Arquivo não enviado. Falha no servidor de recepção do Upload.')
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
      }, 2000)
    })
  },


  getFileUploadedBucket (url) {
    return new Promise((resolve, reject) => {
      apiClient.get(url)
      .then(resp => {
        resolve(resp)
      })
      .catch ((error) => {
        reject(error)
      })
    })
  },


  storeFileUpload(item, parent_id, url) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {        
        let obj = this.geraObjFileStore(item, parent_id)
        apiClient.post(`${url}`, {
          file: obj
        })
        .then(response => {
          if (response.data.status) {
            resolve(response)
          } else {
            reject("Um erro ocorreu ao gravar Arquivo. 'storeFileUpload'.")
          }
        })
        .catch ((error) => {
          reject(error)
        }) 
      })
    })

  },


  geraObjFileStore (item, parent_id) {
    return {
      name: item.nome,
      ext: item.ext,
      type: item.type,
      size: item.size,
      nm_fileorig: item.nm_fileorig,
      parent_id: parent_id,
      filename: item.nameFileUpload
    }
  },


  /**
   * Gera url para download de um arquivo.
   *
  */
  geraUrlToDownloadFile(url, { file }) {
    return new Promise((resolve, reject) => {
      apiClient.post(url, {
        file
      })
      .then(response => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
    })
  },


  /**
     * Gera várias url's para download de vários arquivos.
     *
  */
  geraUrlToDownloadFiles(url, { files }) {
    return new Promise (async (resolve, reject) => {
      apiClient.post(url, {
        files
      })        
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
    })

  },



  /**
     * Efetua download de um arquivo de uma URL.
     *
  */
  downloadDropBoxByUrl(item) {
    return new Promise((resolve, reject) => {

      if (/(xls|xlsx|doc|docx)$/i.test(item.ext)) {
        //https://view.officeapps.live.com/op/embed.aspx?src=
        //https://docs.google.com/gview?url=
        try {
          item.progressFile = 100
          let fileURL = `https://view.officeapps.live.com/op/embed.aspx?src=${item.url}`
          window.open(fileURL);
          resolve()
  
        } catch (e) {
          this.$toaster.error('Erro ao gerar vizualização do arquivo Microsoft')
          reject(error)
        }

      } else if ( /(jpe?g|jpeg|png|gif)$/i.test( item.ext )) {
        //window.open(item.url)
        //this.openNewTabFile(item, item.url)
        /*var win = window.open(item.url, '_blank');
        win.focus();*/
        //resolve()
        this.downloadFileFromUrl(item)
        .then(resp => {
          /*var fileBlob = new Blob([resp.data], {type: `${item.type}`})
          var fileURL = URL.createObjectURL(fileBlob);
          this.openNewTabFile(item, fileURL) */
          //var file = {preview: true, file: fileURL}

          //console.log(resp.data)
          var fileBlob = new Blob([resp.data], {type: `${item.type}`})
          var fileURL = URL.createObjectURL(fileBlob);
          window.open(fileURL);
          resolve()
        })
      
      } else {
        this.downloadFileFromUrl(item)
        .then(resp => {
          var fileBlob = new Blob([resp.data], {type: `${item.type}`})
          var fileURL = URL.createObjectURL(fileBlob);
          window.open(fileURL);
          resolve()
        })
        //window.open(item.url)
        //http://docs.google.com/viewer?url=
        //this.openNewTabFile(item, item.url)
        //resolve()
        /*this.downloadFileFromUrl(item)
        .then(resp => {
          var fileBlob = new Blob([resp.data], {type: `${item.type}`})
          var fileURL = URL.createObjectURL(fileBlob);
          window.open(fileURL)
          resolve()
        })
        .catch((error) => {
          reject(error)
        }) */
      }

    })
  },


  /**
     * Efetua download de arquivo de uma URL.
     *
  */
  downloadFileFromUrl (item) {
    return new Promise((resolve, reject) => {
      outAxios({
        method: 'get',
        url: item.url,
        onDownloadProgress: (progressEvent) => {
          item.progressFile = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        },
        responseType: 'arraybuffer'
      })
      .then(response => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
    })

  },



  /**
     * Efetua download de arquivo de uma URL e adiciona arquivos em ZIP.
     *
  */
  downloadUrlAndAddTozip (url, nome, ext, zip) {
    return new Promise((resolve, reject) => {
      axiosExt({
        method: 'GET',
        url,
        responseType: 'blob'
      })
      .then(({ data }) => {
        zip.file(`${nome}.${ext}`, data);
        resolve(zip)
      })
      .catch((error) => {
        reject(error)
      })
    })
    
  },


  /**
     * Descarrega arquivo e junta num ZIP e efetua download do ZIP.
     *
  */
  downloadFilesInZipFile(files) {
    return new Promise((resolve, reject) => {
      var zip = new JSZip();
      Promise.all(files.map(async (url) => {
        await sleep(500);
        return this.downloadUrlAndAddTozip(url.url, url.nome, url.ext, zip)
      }))
      .then(() => {
        zip.generateAsync({
            type: "blob"
        })
        .then((content) => {
          var a = document.createElement('a');
          a.download = "folder" + new Date().getTime();
          a.href = URL.createObjectURL(content);
          a.setAttribute('download', 'files.zip');
          document.body.appendChild(a);
          a.click();
          a.remove();
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
      })
      .catch((error) => {
        reject(error)
      })
    })
  },


  openNewTabFile(item, url) {
    var text = `${item.nome}.${item.ext}`

    /*var newwindow2=window.open('', 'name','height=200,width=150');
    var tmp = newwindow2.document;
    tmp.write('<html><head><title>popup</title>');
    tmp.write('<link rel="stylesheet" href="js.css">');
    tmp.write('</head><body><p>this is once again a popup.</p>');
    tmp.write(`<p><a href="${url}"</a>.</p>`);
    tmp.write('<p><a href="javascript:self.close()">close</a> the popup.</p>');
    tmp.write('</body></html>');
    tmp.close();

    return*/

    /*setTimeout(function () {
      window.open(
          url,
          '_blank'
      );
    }, 1000); */

    //http://docs.google.com/viewer?url=
    url = `http://docs.google.com/viewer?url=${url}`
    console.log(url)

    var element = document.createElement('a');
    element.setAttribute('href', url)
    element.setAttribute('target', "_blank")
    element.setAttribute('download', text)
    document.body.appendChild(element);
    element.click(); 
    document.body.removeChild(element);
  },

  promisse1 () {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
      console.log('Promisse 1')
      resolve()
      }, 2000);
    })
  },

  promisse2 () {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        console.log('Promisse 2')
        resolve()
      }, 2000);
    })
  },


  promisse3 () {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        console.log('Promisse 3')
        resolve()
      }, 2000);
    })
  },

}


// WEBPACK FOOTER //
// ./src/utils/filesDropBox.js